import { useMemo } from 'react'

export default function useClientAbbreviation (client) {
  return useMemo(() => {
    if (client?.clientAbbreviation) return [client?.clientAbbreviation, true]
    return [client?.shortName || '', false]
  }, [client])
}
